import { useEffect, useState } from 'react';
import { Box, Button, MenuItem, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { useAuth } from 'providers/AuthProvider';
import { useBreakpoints } from 'providers/BreakpointsProvider';
import { useCalendarContext } from 'providers/CalendarProvider';
import { SET_CALENDAR_STATE } from 'reducers/CalendarReducer';
import HolidayCreate from 'components/SS/createHoliday';
import IconifyIcon from 'components/base/IconifyIcon';
import StyledTextField from 'components/styled/StyledTextField';

// { toggleDrawer }
const CalendarHeader = () => {
  const { sessionUser } = useAuth();
  const { calendarApi, view, calendarDispatch, updateView } = useCalendarContext();
  const [open, setOpen] = useState(false);
  const { down } = useBreakpoints();
  const downSm = down('sm');
  const [module, setModule] = useState([]);

  useEffect(() => {
    const roles = sessionUser?.moduleAccess?.map((m) => m.name);
    setModule(roles);
  }, [sessionUser]);

  const handleChangeView = (newView) => {
    if (calendarApi) {
      calendarApi.changeView(newView);
      calendarDispatch({
        type: SET_CALENDAR_STATE,
        payload: { view: newView },
      });
    }
  };

  useEffect(() => {
    if (calendarApi) {
      const currentDate = calendarApi.getDate();
      calendarDispatch({
        type: SET_CALENDAR_STATE,
        payload: { selectedStartDate: currentDate, selectedEndDate: currentDate },
      });
    }
  }, [calendarApi, calendarDispatch]);

  return (
    <>
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: { xs: 1, sm: 2 },
          py: 2,
          pr: 2,
        }}
      >
        {/* <Button
        shape="square"
        variant="outlined"
        color="neutral"
        sx={{
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          borderLeft: 0,
          borderColor: 'divider',

          '&:hover': {
            borderColor: 'divider',
          },
        }}
        onClick={toggleDrawer}
      >
        <IconifyIcon icon="material-symbols:filter-alt-outline" sx={{ fontSize: 20 }} />
      </Button> */}
        <Stack
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          flexWrap="wrap"
          spacing={2}
          sx={{ justifyContent: 'space-between', ml: 2 }}
        >
          <Typography variant="h6" fontWeight={400}>
            <Box component="span" sx={{ display: { xs: 'block', sm: 'inline' } }}>
              {dayjs(calendarApi?.getDate()).format('dddd')},&nbsp;
            </Box>

            <Box component="span">{dayjs(calendarApi?.getDate()).format('DD MMM, YYYY')}</Box>
          </Typography>

          <Button
            size="medium"
            color="neutral"
            variant="outlined"
            onClick={() => updateView('calendar', 'today')}
            sx={{ flexGrow: 1 }}
          >
            Today
          </Button>
        </Stack>
        <Stack
          spacing={1}
          alignItems="center"
          sx={[!downSm && { position: 'absolute', left: '50%', transform: 'translateX(-50%)' }]}
        >
          <Button
            shape="square"
            color="neutral"
            size={downSm ? 'small' : 'medium'}
            onClick={() => updateView('calendar', 'prev')}
          >
            <IconifyIcon
              flipOnRTL
              icon="material-symbols:chevron-left-rounded"
              sx={{ fontSize: 24 }}
            />
          </Button>
          <Typography
            variant="h4"
            fontWeight={400}
            sx={{
              color: 'text.secondary',
              whiteSpace: 'nowrap',
              fontSize: { xs: 'subtitle2.fontSize', sm: 'h5.fontSize', xl: 'h4.fontSize' },
              fontWeight: { xs: 600, sm: 400 },
            }}
          >
            {calendarApi?.view.title}
          </Typography>
          <Button
            shape="square"
            color="neutral"
            size={downSm ? 'small' : 'medium'}
            onClick={() => updateView('calendar', 'next')}
          >
            <IconifyIcon
              flipOnRTL
              icon="material-symbols:chevron-right-rounded"
              sx={{ fontSize: 24 }}
            />
          </Button>
        </Stack>
        <Stack
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          flexWrap="wrap"
          spacing={2}
          sx={{ justifyContent: 'space-between' }}
        >
          {module.includes('HR') && (
            <Button
              shape="square"
              variant="outlined"
              color="neutral"
              sx={{
                '&:hover': {
                  borderColor: 'divider',
                },
                gap: 0.5,
                p: 1,
              }}
              onClick={() => setOpen(true)}
            >
              <IconifyIcon icon="material-symbols:add-2-rounded" sx={{ fontSize: 16 }} />
              Add Holiday
            </Button>
          )}
          <StyledTextField
            select
            size={downSm ? 'small' : 'medium'}
            value={view}
            onChange={(e) => handleChangeView(e.target.value)}
          >
            <MenuItem value="dayGridMonth">Month View</MenuItem>
            <MenuItem value="timeGridWeek">Week View</MenuItem>
            <MenuItem value="timeGridDay">Day View</MenuItem>
          </StyledTextField>
        </Stack>
      </Box>
      <HolidayCreate open={open} setOpen={setOpen} />
    </>
  );
};

export default CalendarHeader;
